// AuthCallback.jsx
import { useEffect } from "react";
import { supabase } from "../functions/supabaseClient";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const { data: { session } } = await supabase.auth.getSession();

      if (session) {
        localStorage.setItem("token", session.access_token);
        localStorage.setItem("refresh_token", session.refresh_token);
        navigate("/dashboard");
      } else {
        navigate("/login");
      }
    };

    run();
  }, []);

  return <p>Signing in...</p>;
}
